<template>
  <div id="tank-liquid-level">
    <div class="vx-card p-6">
      <vs-row vs-type="flex" id="header" class="header row">
        <template v-for="(column, index) in columnData">
          <vs-col
            v-if="column.key == 'vesselName'"
            id="vessel-name-cell"
            class="cell"
            vs-type="flex"
            :class="generateClasses(column)"
            :key="index"
            vs-lg="2"
            vs-sm="2"
            vs-xs="6"
          >
            {{ column.columnName }}
          </vs-col>
          <vs-col
            v-else-if="column.key == 'draft'"
            id="draft-cell"
            class="cell"
            vs-type="flex"
            :class="generateClasses(column)"
            :key="index"
            vs-lg="3"
            vs-sm="2"
            vs-xs="6"
          >
            {{ column.columnName }}
          </vs-col>
          <vs-col
            v-else-if="column.key == 'tilt'"
            id="tilt-cell"
            class="cell"
            vs-type="flex"
            :class="generateClasses(column)"
            :key="index"
            vs-lg="5"
            vs-sm="5"
            vs-xs="6"
          >
            {{ column.columnName }}
          </vs-col>
          <vs-col
            v-else-if="column.key == 'lastUpdatedAt'"
            class="cell"
            vs-type="flex"
            :class="generateClasses(column)"
            :key="index"
            vs-lg="2"
            vs-sm="2"
            vs-xs="6"
          >
            {{ column.columnName }}
          </vs-col>
        </template>
      </vs-row>
      <template v-for="(vessel, index) in vessels">
        <liquid-level-vessel-info
          :columns="columnData"
          :vesselId="vessel.id"
          :vesselName="vessel.name_ja || vessel.name"
          :key="index"
          :initiallyOpened="vessels.length == 1 && index == 0"
        ></liquid-level-vessel-info>
      </template>
    </div>
  </div>
</template>

<script>
import LiquidLevelVesselInfo from "./LiquidLevelVesselInfo.vue";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("ecoShip");
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import { db } from "@/firebase/firebaseConfig.js";

export default {
  components: { LiquidLevelVesselInfo },
  mixins: [DeviceInfoMixin, ColorMixin],
  data() {
    return {
      columnData: [
        {
          columnName: "船名",
          key: "vesselName"
        },
        {
          columnName: "喫水",
          key: "draft"
        },
        {
          columnName: "かしぎ",
          key: "tilt"
        },
        {
          columnName: "データ受信",
          key: "lastUpdatedAt"
        }
      ],
      vessels: []
    };
  },
  watch: {
    onChangeWindowSize() {
      this.showNavMenu();
      this.showHeader();
    }
  },
  async created() {
    await this.getVessels();
  },
  methods: {
    ...mapActions(["fetchVessels"]),

    async getVessels() {
      let res = await this.fetchVessels();

      let enterpriseId = this.$store.state.auth.user.id;
      
      this.vessels = [];
      res.vessels.forEach( async vessel => {
        let level_guage = await db
        .collection("enterprise_vessel_dashboard")
        .doc("e:" + enterpriseId)
        .collection("v:" + vessel.id)
        .doc("level_gauge")
        .get();
        
        if ( level_guage.data() !== undefined ) { 
          this.vessels.push(vessel);
        }
      });
    },
    generateClasses(columnData) {
      let classObj = {};
      classObj[columnData.key] = true;
      if (Object.prototype.hasOwnProperty.call(columnData, "cellClass")){
        classObj[columnData.cellClasses] = true;
      }
      return classObj;
    },
    async showHeader() {
      let deviceInfo = this.getDeviceInfo();
      const card = document.getElementsByClassName("vx-card");
      const header = document.getElementById("header");
      const nameCell = document.getElementById("vessel-name-cell");
      const draftCell = document.getElementById("draft-cell");
      const tiltCell = document.getElementById("tilt-cell");

      if (deviceInfo.deviceType === "PC" && deviceInfo.width <= 1366) {

        card[0].style.width = "100%";
        header.style.width = "100%";

        header.style.display = "flex";

        this.changeSize(nameCell, "vs-lg", "vs-lg-2");
        this.changeSize(draftCell, "vs-lg", "vs-lg-2");
        this.changeSize(tiltCell, "vs-lg", "vs-lg-5");

      } else if  (deviceInfo.deviceType === "iPad" ) {

        card[0].style.width = "100%";
        header.style.width = "100%";

        header.style.display = "flex";

        this.changeSize(nameCell, "vs-lg", "vs-lg-2");
        this.changeSize(draftCell, "vs-lg", "vs-lg-3");
        this.changeSize(tiltCell, "vs-lg", "vs-lg-5");

      } else if (
        deviceInfo.deviceType === "iPhone" &&
        deviceInfo.deviceOrientation === "landscape" &&
        667 < deviceInfo.width && deviceInfo.width <= 812
      ) {

        card[0].style.width = "100%";
        header.style.width = "100%";

        header.style.display = "none";

      } else if (
        deviceInfo.deviceType === "iPhone" &&
        deviceInfo.deviceOrientation === "landscape" &&
        deviceInfo.width <= 667
      ) {

        card[0].style.width = "627px";
        header.style.width = "100%";

        header.style.display = "none";

      } else if ( deviceInfo.deviceType === "iPhone" && deviceInfo.deviceOrientation === "portrait" ) {

        card[0].style.width = "343px";
        header.style.width = "100%";

        header.style.display = "none";

      } else {

        card[0].style.width = "100%";
        header.style.width = "100%";

        header.style.display = "flex";

        this.changeSize(nameCell, "vs-lg", "vs-lg-2");
        this.changeSize(draftCell, "vs-lg", "vs-lg-3");
        this.changeSize(tiltCell, "vs-lg", "vs-lg-5");

      }
    },
    changeSize(cellData, checkValue, chengeValue) {
      cellData.classList.forEach(d => {
        if (d.indexOf(checkValue) != -1) {
          let sm = d;
          cellData.classList.remove(sm);
          cellData.classList.add(chengeValue);
        }
      });
    },
    async showNavMenu() {
      let deviceInfo = this.getDeviceInfo();
      if (deviceInfo.deviceType === "PC") {
        // 端末がPCの場合はサイドメニュー表示。
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
        this.$store.state.reduceButton
        const verticalNavMenuWidth = this.$store.state.reduceButton
          ? "reduced"
          : "default";
        this.$store.dispatch("updateVerticalNavMenuWidth", verticalNavMenuWidth);
      } else {
        // PC以外の場合は非表示。
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
        this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");
      }
    }
  },
  mounted() {

    let routerViewElement = document.getElementsByClassName("router-view")
    routerViewElement[0].style.padding = "2.2rem"

    this.showNavMenu();
    this.showHeader();
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
#tank-liquid-level {
  .header {
    font-weight: bold;
  }
  .row {
    min-height: 43px;
    height: fit-content;
    display: flex;
    border-bottom: solid 1px $aisea-light-gray;
  }
  .cell {
    display: flex;
    flex-wrap: wrap;
    padding: 5px 0px;
    align-items: center;
    &.vesselName {
      margin-left: 10px;
    }
  }
}
</style>
